// extracted by mini-css-extract-plugin
var _1 = "DXkDn";
var _2 = "qZ8IJ";
export { _1 as "header", _2 as "title" }
